import { VideoReadyState } from '@features/motion-media/video-ready-state';
import { asyncScheduler, interval, pipe } from 'rxjs';
import {
  audit, filter, map, observeOn,
} from 'rxjs/operators';
import { isImagesLoaded } from './is-images-loaded';
import { query } from './query';

export const waitForMedia = (parentElement: Document | HTMLElement = document) => pipe(
  audit(() => interval(100).pipe(
    map(() => {
      const videosLoaded = query('video', parentElement).every(
        (video) => video.readyState >= VideoReadyState.HaveCurrentData,
      );

      return videosLoaded && isImagesLoaded(parentElement);
    }),
    filter(Boolean),
    /**
     * Due to how the event loop works, DOM changes can be applied after the
     * grid is applied. This can cause faulty proportions to be used and thus
     * items to be overlapped.
     *
     * By observing this in the async queue, eventual DOM changes will be
     * applied first.
     */
    observeOn(asyncScheduler),
  )),
);
